import React from "react";
import {TYPE_BUSINESS_UNIT} from "../DashboardRow";
import {FaIcon} from "../../../FaIcon";
import {DashboardEditableCell} from "./base/DashboardEditableCell";
import {BU_PERIOD_PERIODIC, BU_PERIOD_TEMPORARY, getBuPeriodName} from "../../../../periods";
import {DatetimeHelper} from "../../../../utils/DatetimeHelper";
import {PeriodDatesCellTooltip} from "./PeriodDatesCellTooltip";
import {EditPeriodDatesModal} from "../../../client/EditPeriodDatesModal";
import { withTranslation } from 'react-i18next';


export class DashboardPeriodDatesCellClass extends DashboardEditableCell {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            value: this.props.itemPeriodDates
        };
    }

    propForOnItemUpdated() {
        return this.props.onPeriodDatesUpdated;
    }

    processingCssClasses() {
        // Marca la celda de Período para que el CSS contenga rangos de fecha largos
        // ("dd/mm/aaaa al dd/mm/aaaa") y no se desborden sobre Presupuesto. Conserva el
        // estado "processing" que pueda venir de la base.
        return `-period-dates ${super.processingCssClasses()}`.trim();
    }

    updateValueOnSubmit(data) {
        // La idea de este metodo es customizar como se actualiza el nuevo estado luego de guardar los cambios en }
        // el editModal pero por ahora no vamos a hacer nada

        // if(this.props.rowType !== TYPE_BUSINESS_UNIT)
        //     throw new Error("no tenia que haber llegado aca")
        //
        // const columnsData = data["business_unit"]["dashboard"][CURRENT_PERIOD_PERIOD_DATES_COLUMN];
        // const columnData = {
        //     "from_date": DatetimeHelper.formatDateFromString(columnsData.from_date),
        //     "to_date": DatetimeHelper.formatDateFromString(columnsData.to_date),
        //     "period_type": columnsData.period_type_enum,
        //     "item_schedule_configuration": this.state.value.itemScheduleConfiguration(),
        // };
        //
        // const itemPeriodDates = new ItemPeriodDates(columnData);
        // this.setState({...this.state, itemPeriodDates: itemPeriodDates});
    }

    renderTooltip() {
        if (!this.hasScheduleConfiguration()) return null;

        return <PeriodDatesCellTooltip itemPeriodDates={this.getItemPeriodDates()}/>;
    }

    shouldRenderCellContent() {
        return this.props.rowType === TYPE_BUSINESS_UNIT;
    }

    getItemPeriodDates() {
        return this.state.value;
    }

    getItemScheduleConfiguration() {
        return this.state.value ? this.state.value.itemScheduleConfiguration() : null;
    }

    hasScheduleConfiguration() {
        const itemScheduleConfiguration = this.getItemScheduleConfiguration();
        return itemScheduleConfiguration ? itemScheduleConfiguration.hasScheduleConfiguration() : false;
    }

    renderCellContent() {
        if (!this.hasScheduleConfiguration()) return this.renderText(); else return <span
            className={"has-toolbox"}>{this.renderText()}&nbsp;&nbsp;&nbsp;<FaIcon iconName="list-ol"/></span>;
    }

    renderText() {
        const { t } = this.props;
        if(this.props.itemPeriodDates.periodType() === BU_PERIOD_PERIODIC)
            return getBuPeriodName(BU_PERIOD_PERIODIC, t)
        else if(this.props.itemPeriodDates.periodType() === BU_PERIOD_TEMPORARY)
            return `${DatetimeHelper.DateToFriendlyStr(this.getItemPeriodDates().fromDate())} al ${DatetimeHelper.DateToFriendlyStr(this.getItemPeriodDates().toDate())}`
    }

    renderEditModal() {
        return <EditPeriodDatesModal onFormSubmitted={this.handleItemModified}
                                     clientName={this.props.clientName}
                                     businessUnitName={this.props.businessUnitName}
                                     businessUnitId={this.props.businessUnitId}
                                     campaignsConfigurationId={this.props.campaignsConfigurationId}
                                     campaignId={this.props.campaignId}
                                     adgroupId={this.props.adgroupId}
                                     itemPeriodDates={this.props.itemPeriodDates}
                                     clickOutsideDontCloseModal={true}/>;
    }
}

export const DashboardPeriodDatesCell = withTranslation()(DashboardPeriodDatesCellClass);
export default DashboardPeriodDatesCell;
